"use client";

import type { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useTranslations } from "@/i18n/LocaleProvider";

// title/updated stay caller-supplied English strings, not t() keys -- the legal body content
// itself (privacy/terms/refunds page.tsx, passed as children) is compliance text that needs a
// professional review before it's translated, not a mechanical string swap. Only this layout's
// "Last updated" chrome routes through i18n.
export default function LegalPageLayout({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  const { t } = useTranslations();
  return (
    <>
      <Header />
      <main className="mx-auto w-full max-w-3xl px-6 py-16">
        <h1 className="font-display text-4xl">{title}</h1>
        <p className="mt-2 text-sm text-muted">{t("legal.lastUpdated", { date: updated })}</p>
        <div className="mt-8 space-y-6 leading-relaxed [&_h2]:mt-8 [&_h2]:font-display [&_h2]:text-xl [&_li]:ml-5 [&_li]:list-disc [&_p]:mb-3 [&_ul]:mb-3">
          {children}
        </div>
      </main>
      <Footer />
    </>
  );
}
